export default "__VITE_ASSET__DnX8B1Bq__"